import Stopwatch from "./Stopwatch";

function App() {
  return <Stopwatch />;
}

export default App;
